module.exports = __webpack_public_path__ + "static/img/banner.d4a91bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/banner.png
// module id = YuVF
// module chunks = 44